export const isDemoAccount = (user) => !!(user && user.isAnonymous);

export const isRealAccount = (user) => !!(user && user.email);

export const isUserLoggedIn = (user) => !!(user.email || user.isAnonymous);
